import type { Order, ProductSummary } from '@modules/OrderPreparation/PackingV2/models/Packing';

export interface OrderProductLineInfo {
  qty: number;
  product?: ProductSummary | null;
}

export const orderHasProduct = (order: Order, productId: number): boolean =>
  getOrderProductLines(order, productId).length > 0;

export const getOrderProductLines = (order: Order, productId: number): OrderProductLineInfo[] => {
  const result: OrderProductLineInfo[] = [];

  for (const line of order.lines) {
    if (line.product_id === productId) {
      result.push({ qty: line.qty, product: line.product });
    }
    if (line.pack?.lines?.length) {
      const packMultiplier = line.qty || 1;
      for (const packLine of line.pack.lines) {
        if (packLine.product_id === productId) {
          result.push({
            qty: (packLine.qty || 1) * packMultiplier,
            product: packLine.product,
          });
        }
      }
    }
  }

  return result;
};

export const getOrderProductQtyTotal = (order: Order, productId: number): number =>
  getOrderProductLines(order, productId).reduce((sum, line) => sum + line.qty, 0);

/** Suma las uds. del producto en los pedidos seleccionados */
export const sumSelectedOrdersProductQty = (
  orders: Order[],
  selectedOrderIds: Set<number>,
  productId: number,
): number =>
  orders
    .filter((order) => selectedOrderIds.has(order.id))
    .reduce((sum, order) => sum + getOrderProductQtyTotal(order, productId), 0);

export interface OrderLineProductSummary {
  product_id: number;
  name: string;
  qty: number;
}

/** Todas las líneas de producto del pedido (packs expandidos) */
export const getOrderAllProductSummaries = (order: Order): OrderLineProductSummary[] => {
  const result: OrderLineProductSummary[] = [];

  for (const line of order.lines) {
    if (line.pack?.lines?.length) {
      const packMultiplier = line.qty || 1;
      for (const packLine of line.pack.lines) {
        result.push({
          product_id: packLine.product_id,
          name: packLine.product?.name ?? packLine.product?.code ?? `Producto ${packLine.product_id}`,
          qty: (packLine.qty || 1) * packMultiplier,
        });
      }
    } else {
      result.push({
        product_id: line.product_id,
        name: line.product?.name ?? line.product?.code ?? `Producto ${line.product_id}`,
        qty: line.qty,
      });
    }
  }

  return result;
};
